import React, { useState } from "react";
import { Alert } from "react-bootstrap";
const unAuthorizedUser = () => {
  return (
    <>
      <div className="account-pages mt-5 mb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card bg-pattern">
                <div className="card-body p-4">
                  <Alert variant="warning">
                    <Alert.Heading></Alert.Heading>
                    <p style={{ fontSize: "18px" }}>
                      You are not authorized to view this page.
                    </p>
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default unAuthorizedUser;
